import { NA_VALUE } from 'helpers/constants';

export const getShortName = name => {
  if (!name) return '';
  const nameArr = name.split(' ');
  const firstName = nameArr[0] || '';
  const lastName = nameArr.filter((n, i) => i > 0).join(' ')[0] || '';
  return `${firstName ? `${firstName} ` : ''}${lastName ? `${lastName}.` : ''}`;
};
export const getInitialsName = name => {
  if (!name) return '';
  const nameArr = name.split(' ');
  const firstName = nameArr[0] || '';
  const lastName = nameArr.filter((v, i) => i > 0).join(' ') || '';
  return [firstName, lastName]
    .filter(v => !!v)
    .map(v => v[0])
    .join('');
};
export const getFullName = (firstName, lastName) => {
  return [firstName || '', lastName || ''].filter(v => !!v).join(' ');
};
export const capitalizeFirstLetter = string => {
  return (string || '').charAt(0).toUpperCase() + string.slice(1);
};
export function formatAddressMultiline(address) {
  if (!address) return '';
  const parts = address.split(',');
  if (parts.length < 2) return address; // fallback if format is unexpected

  const firstLine = parts[0];
  const secondLine = parts
    .slice(1)
    .join(',')
    .trim();

  return `${firstLine}.\n${secondLine}`;
}
export const isNAValue = val => (val || '').toUpperCase() === NA_VALUE;
export const getNAValue = val => (isNAValue(val) ? NA_VALUE : val);
export const cleanHTMLStyle = str =>
  str ? str.replace(/ style="[^"]*"/g, '') : '';
